import { useTranslation } from 'react-i18next'
import classNames from 'classnames'
import { Tooltip } from 'antd'
import styles from './CourseCardBase.module.scss'

export const CourseCardBase = ({
  noAvailable,
  onClick,
  onKeyPress,
  ...props
}: React.PropsWithChildren<React.ComponentProps<'div'>> & {
  noAvailable?: boolean
}) => {
  const { t } = useTranslation()
  const { children } = props
  const events = {
    onClick,
    onKeyPress,
  }
  return (
    <div
      {...props}
      {...(noAvailable ? { tabIndex: -1 } : events)}
      role="button"
      className={classNames(
        styles.card,
        props.className,
        noAvailable ? styles.disabled : ''
      )}
    >
      {children}
      {noAvailable && (
        <Tooltip
          title={t(`courses.show.content.prerequisites.tooltips.notAvailable`)}
          align={{ targetOffset: [0, '-50%'] }}
        >
          <div className={styles.disabledOverlay} />
        </Tooltip>
      )}
    </div>
  )
}
